var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v8zxbvnjka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.076 1.871 13.657 6.302h1.839a1.033 1.033 0 0 1 1.033 1.033v4.132a1.033 1.033 0 0 1-1.033 1.033h-1.033v14.463a1.034 1.034 0 0 1 1.002.783l1.033 4.132a1.033 1.033 0 0 1-1.002 1.283H1.58A1.034 1.034 0 0 1 .578 33.75l1.033-4.132a1.033 1.033 0 0 1 1.002-.783V14.371H1.58a1.033 1.033 0 0 1-1.033-1.033V9.206A1.033 1.033 0 0 1 1.58 8.173h1.839L17.076 1.87zM8.349 8.173H25.8l-8.725-4.03-8.727 4.03zm-3.67 6.198v14.463h2.066V14.371H4.68zm4.132 0v14.463h5.166V14.371H8.81zm7.232 0v14.463h2.066V14.371h-2.066zm4.132 0v14.463h5.165V14.371h-5.165zm7.232 0v14.463h2.066V14.371h-2.066zm4.132-2.066v-2.066H2.613v2.066h28.926zM30.733 30.9H3.419l-.517 2.066H31.25l-.516-2.066z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "v8zxbvnjka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.547 .494)",
    d: "M0 0h33.058v33.058H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.1894ea34aeae7bb7a5c69093a4b7fb7a.svg";
export { ForwardRef as ReactComponent };